var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 57.025C28.275 57.025 26.65 56.15 25.5 54.625L21.75 49.625C21.675 49.525 21.375 49.375 21.225 49.375H20C9.575 49.375 3.125 46.55 3.125 32.5V20C3.125 8.95 8.95 3.125 20 3.125H35C36.025 3.125 36.875 3.975 36.875 5C36.875 6.025 36.025 6.875 35 6.875H20C11.05 6.875 6.875 11.05 6.875 20V32.5C6.875 43.8 10.75 45.625 20 45.625H21.25C22.525 45.625 23.975 46.35 24.75 47.375L28.5 52.375C29.375 53.525 30.625 53.525 31.5 52.375L35.25 47.375C36.075 46.275 37.375 45.625 38.75 45.625H40C48.95 45.625 53.125 41.45 53.125 32.5V25C53.125 23.975 53.975 23.125 55 23.125C56.025 23.125 56.875 23.975 56.875 25V32.5C56.875 43.55 51.05 49.375 40 49.375H38.75C38.55 49.375 38.375 49.475 38.25 49.625L34.5 54.625C33.35 56.15 31.725 57.025 30 57.025Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30C28.6 30 27.5 28.875 27.5 27.5C27.5 26.125 28.625 25 30 25C31.375 25 32.5 26.125 32.5 27.5C32.5 28.875 31.4 30 30 30Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30C38.6 30 37.5 28.875 37.5 27.5C37.5 26.125 38.625 25 40 25C41.375 25 42.5 26.125 42.5 27.5C42.5 28.875 41.4 30 40 30Z",
    fill: "#26B5ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C18.6 30 17.5 28.875 17.5 27.5C17.5 26.125 18.625 25 20 25C21.375 25 22.5 26.125 22.5 27.5C22.5 28.875 21.4 30 20 30Z",
    fill: "#26B5ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 19.375C44.275 19.375 40.625 15.725 40.625 11.25C40.625 6.775 44.275 3.125 48.75 3.125C53.225 3.125 56.875 6.775 56.875 11.25C56.875 15.725 53.225 19.375 48.75 19.375ZM48.75 6.875C46.35 6.875 44.375 8.85 44.375 11.25C44.375 13.65 46.35 15.625 48.75 15.625C51.15 15.625 53.125 13.65 53.125 11.25C53.125 8.85 51.15 6.875 48.75 6.875Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageNotif);
export default __webpack_public_path__ + "static/media/message-notif.08032eae39aa8d3d01c6b06a95f3275c.svg";
export { ForwardRef as ReactComponent };